<script lang="ts" module>
  import type { NavData } from "../../../types/navData";

  export interface NavbarMenubarProps {
    navData?: NavData;
  }
</script>

<script lang="ts">
  import { page } from '$app/state';

  import { NavbarMenu, NavbarMenuGroup, NavbarMenuItem, NavbarMenuSubmenu } from "@agapi/ui/navbar";

  import { menuStyles } from "./navbar.styles";
  import { rewriteUrl, getIsMultiMarket } from '../../../utils';
  import LanguagePickerMobile from "../../language-picker/language-picker-mobile.svelte";

  import * as m from '$lib/parachute/messages';
  import { locales } from '$lib/parachute/runtime';

  const { navData }: NavbarMenubarProps = $props();
  const isMultiMarket = getIsMultiMarket();
</script>

<NavbarMenu colorVariant="primary.subdued" css={menuStyles}>
  <NavbarMenuGroup label="Produktkategorier">
    {#each navData?.bottom_left_nav_items ?? [] as category}
      <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={category.label}>
        {#if category.sub_items}
          <NavbarMenuSubmenu label={category.label}>
            {#if category.path}
            <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={m.showAll({value: ''})} />
            {/if}
            {#each category.sub_items as subCategory}
              {#if subCategory.sub_items}
                <NavbarMenuItem href={rewriteUrl(page, subCategory.path)} label={subCategory.label}>
                  <NavbarMenuSubmenu label={subCategory.label}>
                    <NavbarMenuItem bold href={rewriteUrl(page, subCategory.path)} label={m.showAll({value: subCategory.label})} />
                    {#each subCategory.sub_items as item}
                      <NavbarMenuItem href={rewriteUrl(page, item.path)} label={item.label} />
                    {/each}
                  </NavbarMenuSubmenu>
                </NavbarMenuItem>
              {:else}
                <NavbarMenuItem href={rewriteUrl(page, subCategory.path)} label={subCategory.label} />
              {/if}
            {/each}
          </NavbarMenuSubmenu>
        {/if}
      </NavbarMenuItem>
    {/each}
  </NavbarMenuGroup>

  <NavbarMenuGroup label="Övrigt">
    {#each navData?.bottom_right_nav_items ?? [] as category}
    {#if category.sub_items.length > 0}
      <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={category.label}>
          <NavbarMenuSubmenu label={category.label}>
            {#if category.path}
            <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={m.showAll({value: ''})} />
            {/if}
            {#each category.sub_items as subCategory}
              {#if subCategory.sub_items}
                <NavbarMenuItem href={rewriteUrl(page, subCategory.path)} label={subCategory.label}>
                  <NavbarMenuSubmenu label={subCategory.label}>
                    <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={m.showAll({value: subCategory.label})} />
                    {#each subCategory.sub_items as item}
                      <NavbarMenuItem href={rewriteUrl(page, item.path)} label={item.label} />
                    {/each}
                  </NavbarMenuSubmenu>
                </NavbarMenuItem>
              {:else}
                <NavbarMenuItem href={rewriteUrl(page, subCategory.path)} label={subCategory.label} />
              {/if}
            {/each}
          </NavbarMenuSubmenu>
        </NavbarMenuItem>
        {:else}
         <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={category.label} />
        {/if}
    {/each}
    {#each navData?.top_nav_items ?? [] as category}
    {#if category.sub_items.length > 0}
      <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={category.label}>
          <NavbarMenuSubmenu label={category.label}>
            <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={m.showAll({value: category.label})} />
            {#each category.sub_items as subCategory}
              {#if subCategory.sub_items}
                <NavbarMenuItem href={rewriteUrl(page, subCategory.path)} label={subCategory.label}>
                  <NavbarMenuSubmenu label={subCategory.label}>
                    <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={m.showAll({value: subCategory.label})} />
                    {#each subCategory.sub_items as item}
                      <NavbarMenuItem href={rewriteUrl(page, item.path)} label={item.label} />
                    {/each}
                  </NavbarMenuSubmenu>
                </NavbarMenuItem>
              {:else}
                <NavbarMenuItem href={rewriteUrl(page, subCategory.path)} label={subCategory.label} />
              {/if}
            {/each}
          </NavbarMenuSubmenu>
        </NavbarMenuItem>
        {:else}
         <NavbarMenuItem bold href={rewriteUrl(page, category.path)} label={category.label} />
        {/if}
    {/each}
  </NavbarMenuGroup>

  <!-- Mobile Language Picker -->
  {#if isMultiMarket || locales.length > 1}
    <LanguagePickerMobile />
  {/if}
</NavbarMenu>
